<h2 class="modal-title">Forgot Password</h2>
<p class="modal-dec">Enter your registered email to receive a link to reset your password</p>
<form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
        <label class="form-label">Email <span class="req">*</span></label>
        <input type="email" class="form-control" placeholder="Enter email" formControlName="email"
            (keydown.enter)="confirmEmailAddress($event)">
        @if ((f['email'].invalid && f['email'].touched || submitted) || f['email'].errors?.['apiError']){
        @if(f['email'].errors?.['required']) {
        <span class="required-message">Please enter email</span>
        }
        @if (f['email'].errors?.['email']){
        <span class="required-message">Please enter a valid email</span>
        }
        @if (f['email'].errors?.['apiError']){
        <span class="required-message">{{f['email'].errors?.['apiError']}}</span>
        }
        }
    </div>
    <div class="form-group">
        <label class="form-label">Confirm Email <span class="req">*</span></label>
        <input type="email" class="form-control" placeholder="Enter confirm email" formControlName="confirm_email"
            onpaste="return false" autocomplete="off" #confirmEmailInput>
        @if ((f['confirm_email'].invalid && f['confirm_email'].touched || submitted) ||
        f['confirm_email'].errors?.['apiError']){
        @if(f['confirm_email'].errors?.['required']) {
        <span class="required-message">Please enter confirm email</span>
        }
        @if (f['confirm_email'].errors?.['email']){
        <span class="required-message">Please enter a valid email</span>
        }
        @if (!f['confirm_email'].errors?.['required'] && !f['confirm_email']?.hasError('pattern') &&
        f['confirm_email'].errors?.['confirmEmailNotMatch']){
        <span class="required-message">Email and Confirm Email does not match</span>
        }
        @if (f['confirm_email'].errors?.['apiError']){
        <span class="required-message">{{f['confirm_email'].errors?.['apiError']}}</span>
        }
        }
    </div>
    <div class="form-group">
        <button type="submit" class="btn btn-primary" [disabled]="forgotPasswordForm.invalid">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Send Password Reset Link</span>
        </button>
    </div>
    <div class="form-group">
        <button type="button" class="btn btn-secondary" (click)="switchLogin()">
            <span class="btn-secondary-hover"></span>
            <span class="btn-content">Sign in</span>
        </button>
    </div>
</form>
